import { render, staticRenderFns } from "./SettingsSalaryTemplates.vue?vue&type=template&id=43b05d26"
import script from "./SettingsSalaryTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsSalaryTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports